// extracted by mini-css-extract-plugin
export default {"productLayer":"catalogueProductLayer_productLayer__limqo","selected":"catalogueProductLayer_selected__2ZwbX","resizer":"catalogueProductLayer_resizer__3mvfr"};